import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("textBlock4", component(opts));
  editor.BlockManager.add("textBlock4", block(opts));
};